export default function DevModeBanner({ visible }) {
  if (!visible) return null;
  return (
    <div className="rounded-md bg-amber-50 border border-amber-200 px-4 py-2 text-sm text-amber-900">
      <strong className="font-semibold">Development mode.</strong> This run reached the test server through Cloudflare Tunnel, which adds Cloudflare's edge into the network path. The numbers are indicative only and should not be used for threshold calibration.
    </div>
  );
}
